import { Column } from "./Column";
import ReactLoading from "react-loading";
import Table from "./Table";
import TableBodyData from "./TableBodyData";
import SelecctModal from "../TradeCurrency/SelecctModal";
import { LoadingMode } from "../Components/LoadingMode";
import Modal from "../Components/Modal";
import { Currencies } from "../Components/Currencies";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../ContextAuth/Context";
import { LineGraph } from "./LineGraph";
import { getToken } from "../utils";

export const OneToAllTableExchange = () => {
  const { currencys } = Currencies();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currencyRates, setCurrencyRates] = useState([]);
  const { token: userToken } = getToken();

  const {
    headerTwoRow,
    itemClicked,
    setItemClicked,
    amountInputs,
    headerRowOne,
    openModal,
    allCurrency,
    handleOpenandCloseModal,
    rateType,
  } = Column();

  const fallbackgaraphdata = [
    {
      amount: 0,
    },
    {
      amount: 7,
    },
  ];

  useEffect(() => {
    if (itemClicked.id === "" || rateType === "") {
      return;
    }
    const fetchData = async () => {
      setIsSubmitting(true);
      const url = `${process.env.REACT_APP_BASE_URL}/exchange-rates/get-rate-list`;
      try {
        const response = await axios.post(
          url,
          {
            base_currency_id: itemClicked?.id ?? 1,
            rate_type_id: rateType,
          },
          {
            headers: { Authorization: `Bearer ${userToken}` },
          }
        );

        setCurrencyRates(response?.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsSubmitting(false);
      }
    };
    // setTests(false);
    fetchData();
  }, [userToken, itemClicked.id, rateType]);

  const curerencyRatesArrays = currencyRates?.map((rate) => {
    const currentChange = Number(rate?.rate[rate?.rate?.length - 1]?.amount);
    const lastChange = Number(rate?.rate[0]?.amount);

    return {
      currency: (
        <div className="flex flex-row items-center gap-3 text-p-bk font-normal">
          <img src={rate?.country?.flag} alt={rate?.name} className="w-6 h-4" />
          <p>{rate?.name}</p>

          {/* <p>{rate?.symbol + "-" + rate?.name}</p> */}
        </div>
      ),

      usd: amountInputs
        ? (amountInputs * rate?.price)?.toFixed(4)?.toLocaleString()
        : (rate?.price * 1)?.toFixed(4),
      perChange: (
        <p
          className={
            currentChange > lastChange
              ? "text-green-500"
              : currentChange === lastChange
              ? "tex-p-bk"
              : "text-red-500"
          }
        >
          {`${
            currentChange > lastChange
              ? "+"
              : currentChange === lastChange
              ? ""
              : "-"
          } ${
            rate?.rate.length
              ? rate?.rate.length > 1
                ? (
                    ((rate?.rate[0]?.amount - rate?.rate[1]?.amount) /
                      rate?.rate[1]?.amount) *
                    100
                  )?.toFixed(4)
                : rate?.rate[0]?.amount * 1
              : 0
          }`}
        </p>
      ),
      chart: (
        <LineGraph
          chart24Data={rate?.rate?.length > 1 ? rate?.rate : fallbackgaraphdata}
        />
      ),
      action: (
        <div className="w-full justify-center flex flex-row gap-4 text-p-wh text-xs">
          <button className="py-1.5 px-6 bg-green-500 hover:bg-green-300 rounded active:bg-green-700">
            Buy
          </button>
          <button className="py-1.5 px-6 bg-red-500 hover:bg-red-300 rounded active:bg-red-700">
            Sell
          </button>
        </div>
      ),
    };
  });

  return (
    <div className="flex flex-col items-center overflow-x-auto">
      {!!headerTwoRow.length ? (
        <Table
          headerTwoRow={headerTwoRow}
          data={curerencyRatesArrays}
          headerRowOne={headerRowOne}
        />
      ) : (
        <LoadingMode />
      )}
      <Modal open={openModal === "currency"}>
        <SelecctModal
          setClickedItem={setItemClicked}
          handleOpenandCloseModal={handleOpenandCloseModal}
          modalArrayContent={allCurrency}
          trackModalState=""
          title="Select Currency"
        />
      </Modal>
    </div>
  );
};
